var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 28.75V35h6.25l18.433-18.433-6.25-6.25L5 28.75Zm29.517-17.017c.65-.65.65-1.7 0-2.35l-3.9-3.9a1.66 1.66 0 0 0-2.35 0l-3.05 3.05 6.25 6.25 3.05-3.05Z"
})));
export default SvgEdit;